import { render, staticRenderFns } from "./form-settings.vue?vue&type=template&id=aed942c2&"
import script from "./form-settings.vue?vue&type=script&lang=js&"
export * from "./form-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports